module.exports = __webpack_public_path__ + "img/webicodeProject.471a36ce.jpeg";